/* eslint-disable no-return-assign */
import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import Alert from 'react-s-alert';
import _ from 'lodash';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
// import moment from 'moment';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import Select from 'react-select';
import { get, getJson } from 'session';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';

function PrintOccupationalPermitModal({
  data,
  showTransaction,
  id,
  checkPermit,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    business_establishment_id: '',
    permit_number: '',
  });

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
    showTransaction(id);
  };

  const token = get('token') || '';

  const authProfile = getJson('profile') || '';

  const onChangeSelect = (key) => (item) => {
    setFormData({
      ...formData,
      [key]: _.get(item, 'value'),
    });
  };

  const onChangeText = (e) => {
    const currentOnChangeValue = e.target.value.includes('_')
      ? e.target.value.replace(/_/g, '')
      : e.target.value;

    setFormData({
      ...formData,
      [e.target.name]: currentOnChangeValue,
    });
  };
  // eslint-disable-next-line consistent-return
  const onGenerate = (e) => {
    e.preventDefault();
    if (!_.get(formData, 'business_establishment_id')) {
      return Alert.warning('Business Establishment field is required');
    }
    if (!_.get(formData, 'permit_number')) {
      return Alert.warning('Permit Number field is required');
    }

    // const src = `${process.env.REACT_APP_WS}${c.HEALTH_CERTIFICATE_URI}${_.get(
    //   data,
    //   'id'
    // )}?bearer_token=${token}&business_establishment_id=${_.get(
    //   formData,
    //   'business_establishment_id'
    // )}&permit_number=${_.get(
    //   formData,
    //   'permit_number'
    // )}&email=${_.get(authProfile, 'email')}&date_issued=${moment(
    //   _.get(formData, 'date_issued')
    // ).format('YYYY-MM-DD')}`;

    const src = `${process.env.REACT_APP_WS}${c.OCCUPATIONAL_PERMIT_URI}${_.get(
      data,
      'id'
    )}?bearer_token=${token}&business_establishment_id=${_.get(
      formData,
      'business_establishment_id'
    )}&permit_number=${_.get(formData, 'permit_number')}&email=${_.get(
      authProfile,
      'email'
    )}`;

    const payload = {
      number: _.get(formData, 'permit_number'),
      type: 'Permit',
    };

    checkPermit(payload, (res) => {
      if (_.isEmpty(res.data)) {
        setTimeout(() => {
          window.location.href = src;
        }, 100);
      }
      setTimeout(() => {
        setModal({ isOpen: false });
        showTransaction(id);
      }, 200);
    });
  };

  const options =
    _.get(data, 'included.businessEstablishments').map((item) => {
      return {
        label: _.get(item, 'attributes.name'),
        value: _.get(item, 'id'),
        fullInfo: _.get(item, 'attributes'),
      };
    }) || [];

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <div className="row">
            <div className="col-12 ">
              <div className="form-input-group">
                <label className="form-control-plaintext">
                  Business Establishment to Print
                </label>
                <Select
                  value={
                    options.find(
                      (item) =>
                        _.get(item, 'value') ===
                        _.get(formData, 'business_establishment_id')
                    ) || {}
                  }
                  onChange={onChangeSelect('business_establishment_id')}
                  options={options}
                />
              </div>
            </div>
            <div className="col-12">
              <div className="form-input-group">
                <label className="form-control-plaintext">Permit Number</label>
                <div className="input-group ">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      M-
                    </span>
                  </div>
                  <InputMask
                    required
                    mask="999999"
                    className="form-control"
                    value={_.get(formData, 'permit_number')}
                    name="permit_number"
                    onChange={onChangeText}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 mr-3 btn btn-dark "
        >
          <span className="font-weight-bold">Close</span>
        </button>
        <button
          type="button"
          onClick={onGenerate}
          className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary"
        >
          <span className="font-weight-bold">Generate</span>
        </button>
      </div>
    </Modal.Body>
  );
}

PrintOccupationalPermitModal.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  id: PropTypes.string.isRequired,
  checkPermit: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(PrintOccupationalPermitModal);
